// extracted by mini-css-extract-plugin
export default {"name":"PatientInfoHeader_name__5awY2","description":"PatientInfoHeader_description__IGn7U"};